module.exports = ".mat-form-field-wrapper{\r\n    padding-bottom:0px ;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/user/user-form/user-form.component.css
// module id = ./src/app/ultilities/user/user-form/user-form.component.css
// module chunks = main